<template>
  <div class="ol">
    <div class="ol-h">
      Список объектов
    </div>
    <ul class="ol-list">
      <li
        v-for="z in zones"
        :key="z.id"
        class="ol-item"
        :class="{ active: z.id === selectedId }"
        @click="$emit('select', z)"
      >
        <span class="sw" :style="{ background: colors[z.color] }" />
        <span class="nm" :title="z.name">{{ z.name }}</span>
        <span class="ar">{{ areaLabel(z.latLngs) }}</span>
        <v-icon
          v-if="canEdit"
          class="edit"
          small
          @click.stop="$emit('edit', z)"
        >
          mdi-pencil-outline
        </v-icon>
      </li>
    </ul>
    <button
      v-if="canEdit"
      type="button"
      class="ol-draw"
      :class="{ on: drawing }"
      @click="$emit('toggle-draw')"
    >
      <v-icon v-if="!drawing" small class="ol-draw-ico">
        mdi-shape-polygon-plus
      </v-icon>
      <svg
        v-else
        class="closer-ico"
        width="22"
        height="22"
        viewBox="-13 -13 26 26"
      >
        <circle
          r="11"
          fill="#ff9100"
          stroke="#fff"
          stroke-width="2.5"
        />
        <path
          d="M-4.5,0 L-1.5,3.2 L5,-4"
          stroke="#fff"
          stroke-width="2.6"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      {{ drawing ? 'Замкните контур' : 'Нарисовать зону' }}
    </button>
  </div>
</template>

<script>
  import { ZONE_COLORS, ZONE_SETTINGS_COLORS } from '@/constants/deliveryZones'
  import { areaLabel } from '@/util/geo'

  export default {
    name: 'ZoneObjectsOverlay',
    props: {
      zones: { type: Array, default: () => [] },
      drawing: { type: Boolean, default: false },
      selectedId: { type: [Number, String], default: null },
      // нет права edit → скрываем кнопку рисования и карандаш редактирования
      canEdit: { type: Boolean, default: true },
    },
    data: () => ({ colors: ZONE_SETTINGS_COLORS }),
    methods: { areaLabel },
  }
</script>

<style scoped>
.ol {
  position: absolute;
  top: 14px;
  left: 14px;
  z-index: 6;
  width: 300px;
  max-height: calc(100% - 28px);
  background: rgba(255, 255, 255, 0.96);
  backdrop-filter: blur(6px);
  border-radius: 10px;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.16);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.ol-h {
  margin: 0;
  padding: 14px 16px 10px;
  font-size: 14px;
  font-weight: 500;
}
.ol-list {
  list-style: none;
  margin: 0;
  padding: 0 8px 8px;
  overflow-y: auto;
}
.ol-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 8px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 12px;
}
.ol-item:hover {
  background: #f5f5f5;
}
.ol-item.active {
  background: #fff;
  box-shadow: inset 0 0 0 2px #ff9100;
}
.ol-item .sw {
  width: 14px;
  height: 14px;
  border-radius: 4px;
  flex: 0 0 14px;
}
.ol-item .nm {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 500;
}
.ol-item .ar {
  color: rgba(0, 0, 0, 0.54);
  font-size: 12px;
}
.ol-item .edit {
  color: rgba(0, 0, 0, 0.38);
  cursor: pointer;
  font-size: 17px;
  border-radius: 5px;
  padding: 2px;
}
.ol-item .edit:hover {
  color: #ff9100;
  background: #f5f5f5;
}
.ol-draw {
  margin: 8px;
  height: 42px;
  border: 1px dashed #ff9100;
  background: rgba(255, 145, 1, 0.06);
  color: #ff9100;
  border-radius: 8px;
  font-family: inherit;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: background 0.15s, border-color 0.15s;
}
.ol-draw:not(.on):hover {
  border-style: solid;
  background: rgba(255, 145, 1, 0.16);
}
.ol-draw.on {
  background: #ff9100;
  color: #fff;
  border-style: solid;
}
.ol-draw .closer-ico {
  display: inline-block;
  transform-origin: center center;
  transform-box: view-box;
}
.ol-draw.on .closer-ico {
  animation: checkpulse 1s ease-in-out infinite;
}
@keyframes checkpulse {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.28);
  }
}
</style>
